window.sga.breakpointVariables = {
    xsmall: 374,
    small: 768,
    smallDown: 768,
    smallUp: 769,
    medium: 1024,
    mediumDown: 1024,
    mediumUp: 1025,
    large: 1280,
    largeDown: 1279,
    largeUp: 1280,
    veryLargeUp: 1440
  };